module.exports = __webpack_public_path__ + "media/images/brand/youtube_link-4156a3c342e955c7f6648e148c5faae6.svg";